import { Action } from 'vuex';
import { RootState } from '../types';

const actions: Record<string, Action<{}, RootState>> = {
  /**
   * Fired to scroll to a row. Subscribed to by GridList.vue
   */
  scrollToRow({ commit }, { id }: { id: string }) {
    commit('SCROLL_TO_ROW', {
      id,
    });
  },
};

// mutations
const mutations = {
  SCROLL_TO_ROW() {},
};

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions,
  mutations,
};
